import React from 'react';
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import logoCS from './sdzcr_logo_cz_cb.png'
import logoDE from './sdzcr_logo_de_cb.png'
import './Logo.css'

const Logo = ({style}) => {
    const { t, i18n } = useTranslation()

    if (i18n.language === 'de') {
        return (<Link {...{style}} className="Logo" to={'/content/2433'}><img src={logoDE} alt="" className="Logo"/></Link>)
    } else {
        return (<Link {...{style}} className="Logo" to={'/content/11'}><img src={logoCS} alt="" className="Logo"/></Link>)
    }
}

export default Logo
